<div class="contents">
  <div class="table-area-box">
    <app-table [data]="areas" [keyword]="keyword" [lang]="lang" (kw)="setKeyword($event)"></app-table>
  </div>
</div>